import React, { useEffect, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { IDistributor } from "../../interfaces/distributor.interface";
import { getApi } from "../../services/http.service";
import moment from "moment";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const DistributorDetail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState<IDistributor>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchDistributor();
  }, []);

  const fetchDistributor = async () => {
    try {
      const result = await getApi(
        ROUTES.DISTRIBUTOR_BY_ID + params?.distributorId
      );
      setEmployee(result?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <div className="d-flex">
        <button className="nav-link" onClick={() => navigate(-1)}>
                    <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
        </button>
        <h4 className="ms-2">Distributor</h4>
      </div>
      <section>
        <h3>{employee?.firmName}</h3>
        <div className="table-responsive my-3">
  <table className="table table-bordered table-striped">
    <tbody>
      <tr>
        <th>Email</th>
        <td>{employee?.email}</td>
      </tr>
      <tr>
        <th>Phone</th>
        <td>{employee?.phone}</td>
      </tr>
      <tr>
        <th>Director Name</th>
        <td>{employee?.directorName || "-"}</td>
      </tr>
      <tr>
        <th>Joint On</th>
        <td>{moment(employee?.createdAt).format("DD MMMM YYYY")}</td>
      </tr>
      <tr>
        <th>Address</th>
        <td>
          <div>{employee?.address?.street}</div>
          <div>
            {employee?.address?.city}, {employee?.address?.state},{" "}
            {employee?.address?.pincode}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

      </section>
    </div>
  );
};

export default DistributorDetail;
